import ImageWrapper from "../ImageComponent/ImageWrapper";
import toast from "react-hot-toast";
import { useEffect, useReducer } from "react";
import { getTestimonialData } from "@/pages/api";
import TestimonialBox from "./TestimonialBox";
import { useRouter } from "next/router";

const initialState = {
  testimonialData: [],
  currentPage: 1,
  recordsPerPage: 10,
  isHovered: false,
  isLoading: false,
};

const reducer = (state, action) => {
  switch (action.type) {
    case "SET_TESTIMONIAL_DATA":
      return { ...state, testimonialData: action.payload };
    case "SET_CURRENT_PAGE":
      return { ...state, currentPage: action.payload };
    case "SET_IS_HOVERED":
      return { ...state, isHovered: action.payload };
    case "SET_LOADING":
      return { ...state, isLoading: action.payload };
    default:
      return state;
  }
};

const TestimonialComponent = () => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const router = useRouter();
  const { currentPage, recordsPerPage, testimonialData, isHovered } = state;

  useEffect(() => {
    (async () => {
      try {
        dispatch({ type: "SET_LOADING", payload: true });
        const response = await getTestimonialData(currentPage, recordsPerPage);
        if (response.status === 200) {
          const data = response.data;
          if (data.statusCode === 200) {
            dispatch({ type: "SET_TESTIMONIAL_DATA", payload: data.body });
          }
        }
      } catch (error) {
        toast.error("Error fetching testimonial details");
      } finally {
        dispatch({ type: "SET_LOADING", payload: false });
      }
    })();
  }, [currentPage, recordsPerPage]);

  const handleMoreButton = () => {
    toast("Coming soon!!");
  };
  return (
    <div>
      <div className="flex flex-col text-center items-center justify-center gap-2 md:gap-5 pt-10 md:pt-8">
        <div className="flex align-top items-start relative w-7 h-5 md:w-9 md:h-7 lg:w-10 lg:h-8 xl:w-12 xl:h-10">
          <ImageWrapper
            src="/icons/Group6488.svg"
            alt="Title Image"
            className="w-full h-full top-0 left-0 object-cover"
          />
        </div>
        <p className="text-Default font-light text-xl lg:text-3xl 2xl:text-4xl font-bastoni leading-6 md:leading-8 lg:leading-10">
          Speaking from their hearts
        </p>
        <p className="text-Default font-light capitalize text-base lg:text-xl tracking-widest leading-3">
          Testimonial
        </p>
      </div>
      <div className="pt-4 sm:pt-6 md:pt-10 lg:pt-10 xl:pt-14 2xl:pt-16 px-6 xs:px-8 sm:px-12 md:px-16 lg:px-20 xl:px-35">
        <div className="flex justify-end pb-2 md:pb-6 lg:pb-8 text-Default">
          <button
            type="button"
            className="flex md:hidden text-sm cursor-pointer hover:scale-100"
            onClick={() => router.push("/about-us/testimonies")}
          >
            more
          </button>
          <button
            type="button"
            className="hidden md:flex text-sm cursor-pointer hover:scale-100"
            onClick={() => router.push("/about-us/testimonies")}
          >
            View all
          </button>
        </div>
        <div className="flex flex-row gap-4 items-start justify-start overflow-x-auto scrollbar-hide pt-2 pl-4 pb-12 xs:pb-16 md:pb-24 lg:pb-36">
          {testimonialData &&
            testimonialData.map((tData, index) => (
              <div key={`tData-${index}`}>
                <TestimonialBox
                  data={tData}
                  handleMoreButton={handleMoreButton}
                />
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};

export default TestimonialComponent;
